/* 
  Custom Select Component from kynah project
  - Handles the custom select functionality
*/
class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute("data-id");
    this.trigger = this.querySelector("[data-select-trigger]");
    this.valueSpan = this.querySelector("[data-select-value]");
    this.options = this.querySelectorAll("[data-select-option]");
    this.customSelect = this.querySelector(".custom-select");
    this.nativeSelect = document.querySelector(`select#${this.id}`);
    this.form = this.closest("form");
    
    document.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        this.customSelect.classList.remove("open");
      }
    });

    this.addEventListener("click", () => {
      this.customSelect.classList.toggle("open");
    });

    this.options?.forEach((option) => {
      option.addEventListener("click", () => {
        const value = option.dataset.value;
        this.setValue(value);
        this.nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    this.nativeSelect?.addEventListener("change", () => {
      const value = this.nativeSelect.value;
      this.setValue(value);
    });

    this.form?.addEventListener("reset", () => {
      this.setValue(this.nativeSelect.options[0].textContent);
    });
  }

  setValue(value) {
    const selectedOption = Array.from(this.options).find(option => option.dataset.value === value);
    
    if (selectedOption) {
      const optionContent = selectedOption.querySelector('.option-content');
      if (optionContent) {
        this.valueSpan.innerHTML = optionContent.outerHTML;
      } else {
        this.valueSpan.textContent = value;
      }
    } else {
      this.valueSpan.textContent = value;
    }
    
    this.nativeSelect.value = value;
  }
}

if (!customElements.get("custom-select")) {
  customElements.define("custom-select", CustomSelect);
}